import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="basketball.id" />
      <TextField source="basketball.seasonWins" />
      <TextField source="basketball.seasonLosses" />
      <TextField source="basketball.seasonTies" />
      <TextField source="basketball.seasonPercentWins" />
      <TextField source="basketball.districtWins" />
      <TextField source="basketball.districtLosses" />
      <TextField source="basketball.districtTies" />
      <TextField source="basketball.districtPercentWins" />
      <TextField source="basketball.homeWins" />
      <TextField source="basketball.homeLosses" />
      <TextField source="basketball.homeTies" />
      <TextField source="basketball.roadWins" />
      <TextField source="basketball.roadLosses" />
      <TextField source="basketball.roadTies" />
      <TextField source="basketball.streak" />
      <TextField source="basketball.differential" />
      <TextField source="basketball.teamGameCount" />
      <TextField source="basketball.totalPoints" />
      <TextField source="basketball.pointsAgainst" />
      <TextField source="basketball.rebounds" />
      <TextField source="basketball.threePointFieldGoals" />
      <TextField source="basketball.pointsPerGame" />
      <TextField source="basketball.pointsAgainstPerGame" />
      <TextField source="basketball.reboundsPerGame" />
      <TextField source="basketball.threePointFieldGoalsPerGame" />
    </SimpleShowLayout>
  );
};

export default Tab;
